var React = require('react');

function SmallX (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.9 4.5l2.8-2.8c.4-.4.4-1 0-1.4s-1-.4-1.4 0L4.5 3.1 1.7.3C1.3-.1.7-.1.3.3s-.4 1 0 1.4l2.8 2.8L.3 7.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3l2.8-2.8 2.8 2.8c.2.2.4.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L5.9 4.5z"}));
}

SmallX.defaultProps = {"width":"9","height":"9","viewBox":"0 0 9 9"};

module.exports = SmallX;

SmallX.default = SmallX;
